import {
    getScopeValuesByField,
    hasFilterScope,
} from 'components/SentenceFilter/helpers';
import FilterItemDisplay from 'components/Shared/filters/FilterItemDisplay';
import FilterItemEdit from 'components/Shared/filters/FilterItemEdit';
import React from 'react';
import { useSelector } from 'store/hooks';
import { useTranslation } from 'react-i18next';
import Flex from 'ui/Flex/Flex';

type DefaultFiltersSharingProps = {
    filters: (DashboardFilterT & WithScopes)[] | undefined;
    canEdit: boolean;
    onFilterValueChange: (
        updatedProps: Partial<DashboardFilterT & WithScopes>,
        filterKey: number,
    ) => void;
    isLoading?: boolean;
};

const DefaultFiltersSharing = ({
    filters,
    canEdit = false,
    onFilterValueChange,
}: DefaultFiltersSharingProps): React.ReactElement => {
    const { t } = useTranslation('components');

    const userScopes = useSelector((vision) => vision.vision.user.scopes);
    const currentScopes = useSelector((state) => state.vision.scopes);

    const getFilterItem = (filter: DashboardFilterT & WithScopes) => {
        const filterWithScopes = filter;
        if (hasFilterScope(filter.field, userScopes, currentScopes)) {
            filterWithScopes.scopes = getScopeValuesByField(
                filter.field,
                userScopes,
                t,
                currentScopes,
            );
        }

        if (canEdit) {
            return (
                <FilterItemEdit
                    key={`${filterWithScopes.key}`}
                    filter={filterWithScopes}
                    onFilterValueChange={onFilterValueChange}
                />
            );
        } else {
            return (
                <FilterItemDisplay
                    key={`${filterWithScopes.key}`}
                    filter={filterWithScopes}
                />
            );
        }
    };

    return (
        <Flex padding="16px" flexWrap="wrap">
            {filters &&
                filters
                    .sort((f1, f2) => f1.displayIndex - f2.displayIndex)
                    .map((filter) => {
                        return getFilterItem(filter);
                    })}
        </Flex>
    );
};

export default DefaultFiltersSharing;
